// @flow
import React from 'react';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { AlertTitle } from '@material-ui/lab';
import Alert from '@material-ui/lab/Alert';
import clsx from 'clsx';
import strings from 'strings';
import { When } from 'UI/components/atoms/When';

import { useStyles } from './ProfileAlert.styled';

type ProfileAlertProps = {
  buttonUrl: string,
  complementaryCopies: Object[],
  loading: boolean,
  primaryText: string,
  secondaryText?: string,
  title: string
};

export const ProfileAlert = ({
  buttonUrl,
  complementaryCopies,
  loading,
  primaryText,
  secondaryText = null,
  severity,
  title
}: ProfileAlertProps) => {
  const classes = useStyles();

  if (loading) return null;

  return (
    <Alert
      action={
        buttonUrl && (
          <Button
            color="inherit"
            size="small"
            className={classes.learnMoreBtn}
            href={buttonUrl}
            target="_blank"
            variant="outlined"
          >
            {strings.inventoryProfiles.common.emailValidationStatus.alert.learnMoreBtn}
          </Button>
        )
      }
      severity={severity}
      className={classes.emailValidationWarning}
      key={primaryText}
    >
      {title && <AlertTitle>{title}</AlertTitle>}

      <div
        className={classes.primaryText}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: primaryText
        }}
      />
      <Typography paragraph className={classes.secondaryText}>
        {secondaryText}
      </Typography>
      {complementaryCopies?.map(item => (
        <When key={item.id} condition={item.copy}>
          <Typography
            className={clsx(item.id === 'validationDate' && classes.secondaryText)}
            paragraph
          >
            {item.copy}
          </Typography>
        </When>
      ))}
    </Alert>
  );
};
